import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Emparejamiento actual:")
], -1)

import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import {
  EquipoDisponibleParaModificacionDTO,
  ModificarPairingTorneoEquiposDTO,
} from "@/interfaces/Torneo";
import {
  getEquiposDisponiblesAsync,
  modificarPairingTorneoEquipos,
} from "@/services/TorneosService";
import { ref, watch, computed, onMounted } from "vue";

interface Equipo {
  id: number;
  nombre: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalModificarPairingEquipos',
  props: {
    modelValue: { type: Boolean },
    equipoOriginal1: {},
    equipoOriginal2: {},
    numeroRonda: {},
    idTorneo: {}
  },
  emits: ["update:modelValue", "guardar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const isGenerating = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const nuevoIdEquipo1 = ref<number | null>(null);
const nuevoIdEquipo2 = ref<number | null>(null);
const equiposDisponibles = ref<EquipoDisponibleParaModificacionDTO[]>([]);

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

const emit = __emit;

watch(
  () => props.modelValue,
  (open) => {
    if (open && props.equipoOriginal1 && props.equipoOriginal2) {
      nuevoIdEquipo1.value = props.equipoOriginal1.id;
      nuevoIdEquipo2.value = props.equipoOriginal2.id;
    }
  },
  { immediate: true }
);

watch(
  () => showSuccessModal.value,
  (nuevo, anterior) => {
    if (!nuevo && anterior) {
      location.reload();
    }
  }
);

onMounted(async () => {
  const response = await getEquiposDisponiblesAsync(props.idTorneo);
  equiposDisponibles.value = response.data;
});

async function confirmarCambio() {
  isGenerating.value = true;

  if (
    props.equipoOriginal1 &&
    props.equipoOriginal2 &&
    nuevoIdEquipo1.value &&
    nuevoIdEquipo2.value
  ) {
    const request: ModificarPairingTorneoEquiposDTO = {
      idEquipo1Old: props.equipoOriginal1.id,
      idEquipo2Old: props.equipoOriginal2.id,
      idEquipo1: nuevoIdEquipo1.value,
      idEquipo2: nuevoIdEquipo2.value,
      numeroRonda: props.numeroRonda,
      idTorneo: props.idTorneo,
    };

    try {
      await modificarPairingTorneoEquipos(request);
      showSuccessModal.value = true;
    } catch (error) {
      showErrorModal.value = true;
    } finally {
      isGenerating.value = false;
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Modificar emparejamiento")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("p", null, _toDisplayString(_ctx.equipoOriginal1?.nombre) + " vs " + _toDisplayString(_ctx.equipoOriginal2?.nombre) + " " + _toDisplayString(showSuccessModal.value), 1)
                ]),
                _createVNode(_component_v_select, {
                  modelValue: nuevoIdEquipo1.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nuevoIdEquipo1).value = $event)),
                  items: equiposDisponibles.value,
                  "item-title": "nombreEquipo",
                  "item-value": "idEquipo",
                  label: "Nuevo equipo 1"
                }, null, 8, ["modelValue", "items"]),
                _createVNode(_component_v_select, {
                  modelValue: nuevoIdEquipo2.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevoIdEquipo2).value = $event)),
                  items: equiposDisponibles.value,
                  "item-title": "nombreEquipo",
                  "item-value": "idEquipo",
                  label: "Nuevo equipo 2"
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "secondary",
                  variant: "tonal",
                  text: "",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:modelValue', false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "tonal",
                  onClick: confirmarCambio
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Guardar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Emparejamiento cambiado con exito.",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "Ha ocurrido un error. Inténtalo de nuevo o contacta al administrador.",
      "onUpdate:isVisible": _cache[6] || (_cache[6] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})